const page_faq = document.getElementById("faq-page");

if (page_faq) {
  //% Define all FAQ boxes
  const faq_boxes = page_faq.querySelectorAll(".faq");

  //% Loop through faq boxes
  faq_boxes.forEach((faq) => {
    const answer = faq.querySelector(".answer");
    const icon = faq.querySelector("svg");

    //$ Add click event to each faq box
    faq.onclick = () => {
      //$ Toggle active class on all relevant elements
      faq.classList.toggle("active");
      answer.classList.toggle("active");
      icon.classList.toggle("active");
    };
  });
}
